const trustPilot ={
  Trustpilot: {
    id: 'trustpilot-script',
    src: 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
    async: false
  }
};

export default trustPilot;
